module.exports = __webpack_public_path__ + "img/yael.94203c22.png";